import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class MedicalProductivity extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.getDate = this.getDate.bind(this);

		this.state = {
			health_facilities_id:"all",
			health_facilities: [],

			convoke_places:[],
			convoke_places_id:"all",
			convoke_places_name:"",

			table_list:[],
			listado:[],
			start_date 	:"",
			end_date 	:"",

			years:[{id:'2020', name:'2020'}],

			year:"",
			start_month:"",
			end_month:"",
			type:"",
			months:[
				{id:'1', name:'Enero'},
				{id:'2', name:'Febrero'},
				{id:'3', name:'Marzo'},
				{id:'4', name:'Abril'},
				{id:'5', name:'Mayo'},
				{id:'6', name:'Junio'},
				{id:'7', name:'Julio'},
				{id:'8', name:'Agosto'},
				{id:'9', name:'Septiembre'},
				{id:'10', name:'Octubre'},
				{id:'11', name:'Noviembre'},
				{id:'12', name:'Diciembre'}
			],
			
			change_check: false,

			//test datatable to export
			columns:[
				{title:'Fecha'},
				{'title': 'Médico'},
				{'title': 'Aceptados'},
				{'title': 'Rechazados'},
				{'title': 'Total'}
			],
			filename:"Productividad Médica",
			medical_staff_id:"all",
			medical_staff:[],
			aceptados:"0",
			rechazados:"0",
			totales:"0",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'clinic_history/years_has_hc?health_facilities_id='+this.state.health_facilities_id, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					years: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'medical_staff/has_hc', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					medical_staff: response
				});
			}
		});

		this.getDate();		

		this.getConvokePlace();

		this.setTable();

	}

	getDate(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
				year:date[2]
			});
		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	setTable(){
 		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);

		var targets = [];

		if(this.state.type === 'details'){
			targets = [2,3,4]
		}else{
			this.state.columns.map((c, i)=>{
				if(i > 0){
					targets.push(i);
				}
			});
		}


		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
               	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] })
						doc.content.splice(3, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'12%', fontSize:7}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:7 }
								: {text:"", width:0},
							]
						});

						if(this.state.type === 'details'){
							doc.content[4].table.body.map((b, i)=>{
	                			b.map((t, j)=>{
	                				if(j > 1){
	                					b[j].alignment = 'right' 
	                				}                				            				
	                			})
	                		});
							doc.content[4].table.widths=["10%","60%","10%","10%","10%"];

						}else{
							var w = ['30%'];

							var aux = 60 / (this.state.columns.length - 2);

							this.state.columns.map((c, i)=>{
								if(i > 0 && this.state.columns.length - 1){
									w.push(aux+'%');
								}
							});

							w.push('10%');

							doc.content[4].table.body.map((b, i)=>{
                			b.map((t, j)=>{
                				if(j > 0){
                					b[j].alignment = 'right' 
                				}                				            				
                			})
                		});

							doc.content[4].table.widths = w;
						}

            			
            			if(this.state.type === 'details'){
            				doc.content.splice(5, 0, {
	                			text: 'Aceptados: '+this.state.aceptados+'\t\t'+
	                				  'Rechazados: '+this.state.rechazados+'\t\t'+
	                				  'Totales: '+this.state.totales,
	                			bold:1,
	                			margin:[5,10,0,0]
	                		});
            			}
	                		
                		doc.defaultStyle.fontSize = 7;
                		doc.styles.tableHeader.fontSize = 7;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	}
                	
            	}
            ],
            columnDefs: [{
		        targets: targets,
		        className: 'dt-right'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: function(row, data, dataIndex){
                if(data[0] === "Total General"){
                	$('td', row).attr('style', 'font-weight: bold; color:black');
                	//$('td:eq(0)', row).attr('style', 'font-weight: bold; text-align: right;');
                	
                }
            }

		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
			}, 500);
				
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'type'){
			if(e.target.value === 'details'){
				this.setState({
					start_month:"",
					end_month:""
				});

				this.getDate();
			}else{
				this.setState({
					start_date:"",
					end_date:""
				});
			}
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					year:this.state.year,
					init_month:this.state.start_month,
					end_month:this.state.end_month,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					medical_staff_id:this.state.medical_staff_id,
					health_facilities_id:this.state.health_facilities_id,
					option:this.state.type
				}
				
				fetch(Config.default.apiGateway.URL+'reports/medical_productivity',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
						return;
					}
				}).then(response => {
					
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [];
						if(this.state.type === 'details'){

							response.res.map((r)=>{
								list.push([
									moment(r.Fecha).format('DD/MM/YYYY'),
									r.Medico !== null ? r.Medico : "",
									r.Aceptados,
									r.Rechazados,
									r.Total
								]);
							});

							this.setState({
								listado: list,
								columns:[
									{title:'Fecha'},
									{'title': 'Médico'},
									{'title': 'Aceptados'},
									{'title': 'Rechazados'},
									{'title': 'Total'}
								],
								aceptados:response.accept_count,
								rechazados:response.reject_count,
								totales:response.total
							});

						}else if(this.state.type === 'summary'){

							var columns = [{title:'Médico'}];

							for(var i = parseInt(this.state.start_month); i <= parseInt(this.state.end_month); i++){
								var mes = this.state.months.findIndex(obj => 
									parseInt(obj.id) === i
								);

								if(mes !== -1){
									columns.push({
										title: this.state.months[mes].name,
										id: this.state.months[mes].id 
									});
								}
									
							}

							columns.push({title:'Totales'});

							response.summary.map((s)=>{
								var item = [s.Medico];

								columns.map((c, x)=>{
									if(x > 0 && x < columns.length - 1){
										var index = s.months.findIndex(obj =>
											obj.text === c.id
										);

										if(index !== -1){
											item.push(s.months[index].num);
										}else{
											item.push('0');
										}
									}
										
								});

								var index1 = response.total_by_medico.findIndex( obj =>
									obj.medical_staff_id === s.medical_staff_id
								)

								if(index1 !== -1){
									item.push(response.total_by_medico[index1].total);
								}

								list.push(item);
							});

							var item = []

							columns.map((c, x)=>{
								item.push('');
							});
							list.push(item);

							item = ['Total General']
							columns.map((c, x)=>{
								if(x > 0 && x < columns.length - 1){
									var index = response.total_by_month.findIndex(obj =>
										obj.text === c.id
									);

									if(index !== -1){
										item.push(response.total_by_month[index].num);
									}else{
										item.push('0');
									}
								}

							});
							item.push(response.total);
				
							list.push(item);

							this.setState({
								listado:list,
								columns:columns,
							})
						}
							

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				if(this.state.type === 'details'){
					swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');	
				}else{
					swal('Error', 'El mes final no puede superar más de 6 meses el mes inicial', 'error');
				}
				
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var date_ok = true;

		if(this.state.type === 'details'){
			var ini = moment(this.state.start_date);
			var fin = moment(this.state.end_date);
			

			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		

			
		}else{
			var ini = this.state.year+'-'+
				(this.state.start_month.length === 1 ? '0'+this.state.start_month : this.state.start_month)+'-01';
			var fin = this.state.year+'-'+
				(this.state.end_month.length === 1 ? '0'+this.state.end_month : this.state.end_month)+'-01';


			var aux = moment(ini).add(5, 'months').format('YYYY-MM-DD');


			if(fin > aux){
				date_ok = false;
			}
		}

		return date_ok;
			
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: 'all'//sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{t('sidebar.nav.reports.medical_productivity')}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_medical_productivity"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control" name="type" id="type"
										value={this.state.type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="details">Detallado</option>
										<option value="summary">Resumen</option>
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								{this.state.type === 'details' ?
									<div>
										<div className="col-xs-12 form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required />
										</div>
										<div className="col-xs-12 form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								:this.state.type === 'summary'?
									 <div className="form-group">
										<div className="col-xs-12 form-group" style={{paddingLeft:"0"}}>
											<span className="span-min">Año</span>
											<select className="form-control" name="year" id="year"
												value={this.state.year} onChange={this.handleChange} required>
												<option value="">Seleccione...</option>
												{this.state.years.map((c, i)=>{
													return <option key={i} value={c}>
														{c}
													</option>
												})}
											</select>
										</div>
										<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
											<span className="span-min">Mes Inicio</span>
											<select className="form-control" name="start_month" id="start_month"
												value={this.state.start_month} onChange={this.handleChange} required>
												<option value="">Seleccione...</option>
												{this.state.months.map((c, i)=>{
													return <option key={i} value={c.id}>
														{c.name}
													</option>
												})}
											</select>
										</div>
										<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
											<span className="span-min">Mes Fin</span>
											<select className="form-control" name="end_month" id="end_month"
												value={this.state.end_month} onChange={this.handleChange} required>
												<option value="">Seleccione...</option>
												{this.state.months.map((c, i)=>{
													return <option key={i} value={c.id}>
														{c.name}
													</option>
												})}
											</select>
										</div>
									</div>
								:null}
									

								<div className="form-group">
									<span className="span-min">Medico</span>
									<select className="form-control" name="medical_staff_id" id="medical_staff_id"
										value={this.state.medical_staff_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.medical_staff.map((m, i)=>{
											return <option key={i} value={m.id}>
												{(m.lastname1 !== null ? m.lastname1+' ' : '')+
												(m.lastname2 !== null ? m.lastname2+' ' : '')+
												m.names}
											</option>
										})}
									</select>
								</div>
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											Productividad Médica
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

								<div className="col-xs-12">
									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== "" ?
											<span>
												Lugar de Colecta:   
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}
									</div>
								</div>
								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								{this.state.type === 'details' ?
									<div className="col-xs-12">
										<label>Aceptados:</label><span>{' '+this.state.aceptados}</span>
										<label style={{marginLeft:'7px'}}>Rechazados:</label><span>{' '+this.state.rechazados}</span>
										<label style={{marginLeft:'7px'}}>Totales:</label><span>{' '+this.state.totales}</span>
									</div>
								: null}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}
export default translate('translations')(MedicalProductivity)